import {persist} from '@/lib/vatio-persistence';
import {StepsPath} from './StepsRouting';
import {useSnapshot} from 'valtio';

/**
 * Keep local pages history during buyflows saved,
 * so it can be restored when user open app again after some time
 */
export interface LocalHistoryState {
  pages: Array<StepsPath>;
  last?: StepsPath;
}

// if add any new field, add the new field to the below reset function also
export const store = persist<LocalHistoryState>('history', {
  pages: [StepsPath.Start], // Starting page

  get last() {
    if (!this.pages.length) {
      return StepsPath.Start;
    }

    return this.pages[this.pages.length - 1];
  },
});

export const resetLocalHistoryState = () => {
  store.pages = [StepsPath.Start];
};

export const useLocalHistory = () => useSnapshot(store);

export const addToHistory = (path: StepsPath) => {
  if (store.pages.indexOf(path) !== -1) {
    // deduplicate pages to keep history linear
    return;
  }

  store.pages.push(path);
};

export const popFromHistory = () => {
  return store.pages.pop();
};

/**
 * Remove steps which not valid anymore after manually go back to the previous step.
 *
 * @param pageIndex - index at where to remove the rest of pages
 */
export const removePagesFromHistory = (currentPageIndex: number) => {
  store.pages.splice(currentPageIndex);
};
